import { useAppSelector } from "./store";

export default function useUtmify() {
  const frameId = useAppSelector((state) => state.config.data.frameId);
  const utm_source = "botbrains";
  const utm_medium = "chat";
  const utm_campaign = "frame_" + frameId;
  const utmify = (
    link: string,
    contentLocation: "message_link" | "powered_by_link"
  ) => {
    const url = new URL(link, window.location.origin);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set("utm_source", utm_source);
    searchParams.set("utm_medium", utm_medium);
    searchParams.set("utm_campaign", utm_campaign);
    searchParams.set("utm_content", contentLocation);
    url.search = searchParams.toString();

    return url.toString();
  };
  return utmify;
}
